import type { ComponentType } from 'react';
import type { NodeColor } from '@/lib/prayer-utils';
import {
  LeafIcon,
  SeedIcon,
  SproutIcon,
  type IconProps,
} from './BotanicalIcons';

export const ICON_MAP: Record<NodeColor, ComponentType<IconProps>> = {
  blue: SeedIcon,
  gold: SproutIcon,
  green: LeafIcon,
};
